import { createFileRoute } from "@tanstack/react-router";
import { AdminRecoverLoginPage } from "@/components/admin/AdminRecoverLoginPage";

export const Route = createFileRoute("/pulse-ops-x7k2/recover/login")({
  component: AdminRecoverLoginPage,
});
